import '../styles/styles.css';
import '../styles/global.css';

import { AppProps } from 'next/app';
import Head from 'next/head';
import { Raleway } from 'next/font/google';

const raleway = Raleway({
	subsets: ['latin'],
	display: 'block',
	weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
	style: 'normal',
});

import {
	useServiceWorker,
	useGeolocation,
	useWorker,
	useNotification,
} from '../lib/presentation/hooks';
import AccessibilityProvider, {
	useAccessibilityStore,
} from '@/contexts/accessibility';
import { usePageAnalytics } from '@/hooks/usePageAnalytics';
import { NewsletterProvider } from '@/contexts/NewsletterContext';

export default function App({ Component, pageProps }: AppProps) {
	useServiceWorker({ path: '/workers/sw-pwa.js' });
	useGeolocation({ watchPosition: false, enableHighAccuracy: false });

	const { registration } = useWorker({
		path: '/workers/sw-push-notification.js',
		register: true,
	});
	useNotification(registration);

	const accessibilityStore = useAccessibilityStore();
	usePageAnalytics();

	return (
		<>
			<Head>
				<meta name="viewport" content="initial-scale=1, width=device-width" />
				<link rel="icon" href="/assets/images/favicons/favicon.ico" />
			</Head>

			<AccessibilityProvider value={{ ...accessibilityStore }}>
				<NewsletterProvider>
					<div className={`${raleway.className} text-black`}>
						<Component {...pageProps} />
					</div>
				</NewsletterProvider>
			</AccessibilityProvider>
		</>
	);
}
